import { createContext, useContext } from 'react';
import { State } from '../types/state';

export type ApplicationContextType = {
	application: State;
	setApplication: React.Dispatch<React.SetStateAction<State>>;
};

export const ApplicationContext = createContext<ApplicationContextType>({
	application: {
		open: false,
		closable: true,
		hideToggle: false,
		fullScreen: false,
		float: false
	},
	setApplication: () => {
		console.warn('no application provider');
	}
});
